import React from "react";

interface CustomButtonProps {
  btnName?: string;
  onClick?: () => void;
  customClasses?: string;
  disabledProp?: boolean;
  icon?: React.ReactNode;
  iconPosition?: "left" | "right";
}

const CustomButton: React.FC<CustomButtonProps> = ({
  btnName = "Custom Button",
  onClick,
  customClasses = "",
  disabledProp = false,
  icon,
  iconPosition = "left",
}) => {
  return (
    <button
      type="button"
      disabled={disabledProp}
      onClick={onClick}
      className={`flex items-center justify-center gap-2 bg-bgBtn text-white py-2 px-5 rounded-md ${customClasses} ${
        disabledProp ? "!bg-gray-400 cursor-not-allowed" : ""
      }`}
    >
      {icon && iconPosition === "left" && icon}

      <span>{btnName}</span>

      {icon && iconPosition === "right" && icon}
    </button>
  );
};

export default CustomButton;
